import React from 'react';

function Topics() {
  return (

  <section className="section-2">
    <div className="container">
        <div className="row">
            <div className="col-lg-4 col-sm-12 col-12 box-1">
                <div className="row box" data-aos="fade-left" data-aos-delay="300">
                    <div className="col-lg-2 col-sm-12">
                        <i className="fa fa-desktop" aria-hidden="true"></i>
                    </div>
                    <div className="col-lg-10 col-sm-12">
                        <h3>Pesquisa</h3>
                        <p>Pesquisas Científicas na área de Aprendizagem de Máquina. Desenvolvemos métodos, técnicas em rotulação, mineração e ciência de dados.</p>
                        {/* <p><a href="services.html"><img src="images/plus.png" alt="plus" /></a></p> */}
                    </div>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12 col-12 box-2">
                <div className="row box" data-aos="fade-left" data-aos-delay="500">
                    <div className="col-lg-2 col-sm-12">
                        <i className="fa fa-code" aria-hidden="true"></i>
                    </div>
                    <div className="col-lg-10 col-sm-12">
                        <h3>Inovação</h3>
                        <p>Desenvolvimento de Produtos (softwares) que tem por base aplicações de métodos e técnicas de Inteligência Artificial e Aprendizagem de Máquina</p>
                        {/* <p><a href="services.html"><img src="images/plus.png" alt="plus" /></a></p> */}
                    </div>
                </div>
            </div>
            <div className="col-lg-4 col-sm-12 col-12 box-3">
                <div className="row box" data-aos="fade-left" data-aos-delay="700">
                    <div className="col-lg-2 col-sm-12">
                        <i className="fa fa-comments-o" aria-hidden="true"></i>
                    </div>
                    <div className="col-lg-10 col-sm-12">
                        <h3><a href="services.html">Ensino</a></h3>
                        <p>Aliamos o desenvolvimento tecnológico e científico ao ensino de Inteligência Artificial na graduação e pós-graduação stricto sensu (mestrado e doutorado)</p>
                        {/* <p><a href="services.html"><img src="images/plus.png" alt="plus" /></a></p> */}
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

  );
}

export default Topics;
;